import gql from 'graphql-tag';
export const extraPropertiesGQLQuery = () => gql `
  query ExtraProperties(
    $entityId: String
    $entityType: ExtraPropertyEntityType!
    $keys: [String!]
  ) {
    extraProperties(entityId: $entityId, entityType: $entityType, keys: $keys) {
      key
      value
    }
  }
`;
//# sourceMappingURL=extraProperties.gql.js.map